export const FOLDER_DOCUMENTS = "/api/folder/:param/documents"
export const FOLDER_DOCUMENT = "/api/folder/:param/document/:documentParam"
export const FOLDER_DOCUMENT_DISABLE = "/api/folder/:param/document/:documentParam/deactivate"
export const FOLDER_DOCUMENT_ENABLE = "/api/folder/:param/document/:documentParam/activate"
export const FOLDER_DOCUMENT_DOWNLOAD = "/api/folder/document/:param?is_gu=query_param"
